import { render, staticRenderFns } from "./SpecimenSelectionTable.vue?vue&type=template&id=df70e260&scoped=true"
import script from "./SpecimenSelectionTable.vue?vue&type=script&lang=js"
export * from "./SpecimenSelectionTable.vue?vue&type=script&lang=js"
import style0 from "./SpecimenSelectionTable.vue?vue&type=style&index=0&id=df70e260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df70e260",
  null
  
)

export default component.exports